import { render, staticRenderFns } from "./list.vue?vue&type=template&id=16b5e876&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.css?vue&type=style&index=0&id=16b5e876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5e876",
  null
  
)

export default component.exports